(function(){
  var KLEUR = {"Cotton White":"#F4EFEB","Charcoal Black":"#2F2E30","Muted White":"#BBADA4","Fossil Grey":"#8A8C94","Ash Grey":"#485155","Lava Red":"#ED2F2E","Sunrise Orange":"#F88B17","Pastel Banana":"#F7D475","Forest Green":"#60AD70","Sapphire Blue":"#0163A6","Natural":"#EDE8DF","White":"#F4EFEB","Black":"#2F2E30","Grey":"#8C9099","Red":"#ED2F2E","Orange":"#F88B17","Yellow":"#F3C432","Green":"#3E9C4B","Blue":"#003776","Polymaker Teal":"#64C2CA","Gray":"#8C9099","Purple":"#9572BF","Brown":"#795A4D","Cream White":"#F0E6D2","Clear":"#E8ECEE","Dark Blue":"#030E1A","Light Blue":"#00A0B7","Light Green":"#AEDE9C","Silver":"#C5C6C7","Violet":"#7B4EA0","Anthracite Grey":"#383E42","Charcoal Grey":"#36393B","Traffic Black":"#1E1E1E","Traffic White":"#F1F0EA","Light Grey":"#A9ABAF","Iron Grey":"#52595D","Traffic Yellow":"#F7B500"};

  function norm(s){ return (s||"").trim().toLowerCase(); }
  var index = {}; Object.keys(KLEUR).forEach(function(k){ index[norm(k)] = KLEUR[k]; });

  function verf(root){
    var labels = (root||document).querySelectorAll("label, .variant-option__button-label, .swatch, [data-option-value]");
    labels.forEach(function(el){
      if (el.querySelector(".m4-swatch")) return;
      var txt = norm(el.getAttribute("data-option-value") || el.textContent);
      if (!txt || txt.length > 40) return;
      var hex = index[txt];
      if (!hex) return;
      var dot = document.createElement("span");
      dot.className = "m4-swatch";
      dot.style.background = hex;
      el.insertBefore(dot, el.firstChild);
    });
  }
  function start(){ verf(document);
    var mo = new MutationObserver(function(m){ verf(document); });
    mo.observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();